import { cn } from "@/app/utils/cn";
import { FolderSearch } from "lucide-react";
import { ReactNode } from "react";
import { ClassNameValue } from "tailwind-merge";
interface EmptyMessageProps {
  icon?: ReactNode;
  title?: string;
  description?: string;
  className?: ClassNameValue;
}
export const EmptyMessage = ({
  description,
  icon,
  title,
  className,
}: EmptyMessageProps) => {
  return (
    <div
      className={cn(
        "flex h-[590px] flex-col items-center justify-center rounded-xl border-[1px] border-[#E5E5E5]",
        className,
      )}
    >
      {icon || <FolderSearch size={46} />}
      <h2 className="mb-4 mt-2 text-xl font-semibold max-sm:text-center max-sm:text-lg">
        {title || "Nenhuma informação registrada"}
      </h2>
      <p className="w-[520px] text-center font-medium text-black04 max-sm:w-full max-sm:text-sm">
        {description ||
          "Aqui será exibido as informações solicitadas, por favor tente novamente mais tarde."}
      </p>
    </div>
  );
};
